import ExtendedSelectField from '../extended-select-field/extended-select-field';
import { CustomComponentType } from '../../../../enums';

/**
 * Custom multiselect field for race fields that handles conversion between
 * comma-separated string values (stored in database) and array values (used by multiselect UI)
 */
export default class RaceMultiselectField extends ExtendedSelectField {
	static schema(...extend: any) {
		return ExtendedSelectField.schema(
			{
				type: CustomComponentType.raceMultiselectField,
				multiple: true,
				dataType: 'number'
			},
			...extend
		);
	}

	static get builderInfo() {
		return {
			title: 'Race Multiselect Field',
			group: '',
			weight: 10,
			schema: RaceMultiselectField.schema()
		};
	}

	constructor(component: any, options: any, data: any) {
		super(component, options, data);
	}
}
